import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { BottomSheet } from '@/components/UI/BottomSheet/BottomSheet';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  max-height: calc(100dvh - 100px);
`;

export const StickySection = styled.div`
  position: sticky;
  top: 0;
  z-index: 1;
  margin-top: 10px;
`;

export const Section = styled.div`
  display: flex;
  height: 45px;
  margin: 10px 0 0 0;
  align-items: center;
  justify-content: space-between;
`;

export const SectionTitle = styled(Typography.Header).attrs(() => ({
  $variant: '3',
}))`
  user-select: none;
  color: ${({ theme }) => theme.palette.primary.labels};
`;

export const CreateLink = styled.button`
  user-select: none;
  outline: none;
  border: none;
  background: none;
  cursor: pointer;
  box-shadow: none;
  font-size: 16px;
  font-weight: 500;
  font-family: 'Helvetica Neue', sans-serif;
  color: ${({ theme }) => theme.palette.system.blue};
`;

export const Footer = styled.div`
  display: flex;
  padding: 0;
  min-height: 90px;
  align-items: center;
  justify-content: space-between;
`;

export const Sheet = styled(BottomSheet).attrs(({ theme }) => ({
  hasHeadBorder: false,
  isPageLocked: true,
  isTitleCentered: true,
  shellBackground: theme.palette.secondary.background,
}))``;
